"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pointIsInPaintObject = void 0;
var utils_1 = require("../../../utils");
var pointIsInPaintObject = function (pointerPosPixel, paintObject) {
    var x = pointerPosPixel.x - paintObject.pixelLeft;
    var y = pointerPosPixel.y - paintObject.pixelTop;
    var _a = paintObject.bitMatrix, width = _a.width, height = _a.height, data = _a.data;
    if (!(0, utils_1.isInRange)(0, width)(x) || !(0, utils_1.isInRange)(0, height)(y))
        return false;
    return data.get(y * width + x) === 1;
};
exports.pointIsInPaintObject = pointIsInPaintObject;
